var _desc, _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSolanafloorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "29.7765424%",
    y1: "148.042656%",
    x2: "53.5743544%",
    y2: "-97.6899909%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D53FE8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0CF3B3",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "url(#linearGradient-1)",
    x: 0,
    y: 0,
    width: 501,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    id: "logo-copy",
    transform: "translate(51.000000, 66.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.7344086,333.600199 C119.374121,333.600199 144.416659,327.076658 161.862023,314.029576 C179.307387,300.982495 188.030068,281.692455 188.030068,256.159456 C188.030068,243.392957 186.095603,232.555462 182.226671,223.646971 C178.35774,214.738479 172.308138,206.987391 164.077865,200.393704 C155.847593,193.800018 143.361496,187.06604 126.619575,180.191771 C104.109428,171.353426 90.4978238,165.496268 85.7847618,162.620299 C81.0716999,159.744329 78.7151689,156.272122 78.7151689,152.203677 C78.7151689,145.60999 85.4682129,142.313147 98.9743008,142.313147 C106.712164,142.313147 116.701041,144.031714 128.940934,147.468849 C141.180826,150.905983 152.78762,155.079646 163.761317,159.989838 L163.761317,159.989838 L186.130775,106.959765 C171.217803,100.366078 156.832412,95.3506679 142.974603,91.9135335 C129.116794,88.4763991 114.309338,86.7578319 98.5522356,86.7578319 C67.1787188,86.7578319 42.909967,92.9306447 25.7459802,105.27627 C8.58199339,117.621896 3.90397314e-13,134.877714 3.90397314e-13,157.043723 C3.90397314e-13,174.580123 4.3613409,189.06519 13.0840227,200.498923 C21.8067045,211.932655 37.1417419,222.13884 59.0891348,231.117477 C83.146854,240.657279 97.672933,247.075601 102.667372,250.372444 C107.661811,253.669288 110.15903,257.422077 110.15903,261.630813 C110.15903,269.767703 101.225316,273.836148 83.3578866,273.836148 C71.3993713,273.836148 57.787767,272.012362 42.5230738,268.364791 C27.2583807,264.71722 13.2247111,260.08761 0.422065249,254.475962 L0.422065249,254.475962 L0.422065249,320.34268 C14.0688416,325.393164 27.4342412,328.865371 40.5182639,330.759302 C53.6022866,332.653233 69.0076682,333.600199 86.7344086,333.600199 Z",
    id: "solana",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.40919,329.425659 L332.40919,152.835006 L383.236795,152.835006 L383.236795,91.2385041 L332.40919,91.2385041 L332.40919,84.9316951 C332.40919,76.2423137 333.85036,69.9705425 336.7327,66.1163814 C339.61504,62.2622204 344.219754,60.3351398 350.546841,60.3351398 C360.248376,60.3351398 370.160814,61.7366529 380.284154,64.5396792 L380.284154,64.5396792 L398,11.3522563 C385.06462,7.14771691 373.711013,4.20453936 363.939177,2.52272362 C354.167342,0.840907872 343.797948,1.16584432e-15 332.830996,1.16584432e-15 C304.429401,1.16584432e-15 283.796065,6.86741429 270.930986,20.6022429 C258.065908,34.3370714 251.633369,56.9014327 251.633369,88.2953266 L251.633369,88.2953266 L251.633369,92.289639 L218.310706,112.471428 L218.310706,152.835006 L249.946145,152.835006 L249.946145,329.425659 L332.40919,329.425659 Z",
    id: "foor",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    opacity: 0.554551787
  }), /*#__PURE__*/React.createElement("line", {
    x1: 238.983445,
    y1: 364.798419,
    x2: 383.44489,
    y2: 364.798419,
    id: "Line",
    stroke: "#0CF3B3",
    strokeWidth: 15,
    opacity: 0.398751293,
    strokeLinecap: "square"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanafloorLogo);
export default __webpack_public_path__ + "static/media/solanafloor-logo.3b295a62e6b007a849496a8abbfcbfd5.svg";
export { ForwardRef as ReactComponent };